import { Box, Typography, useTheme } from '@mui/material';

import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { pxToRem } from '@/theme/typography';
import ImageBoxFuture from '../shared/image-box-future';

const OfflineIcon = '/icons/general/offline.svg';

const OfflineDialog: FC = () => {
  const theme = useTheme();
  const intl = useIntl();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'center',
      }}
    >
      <ImageBoxFuture
        img={OfflineIcon}
        title={intl.formatMessage({
          id: 'alt.offline_icon',
        })}
        objectFit='contain'
        sx={{ marginTop: pxToRem(72), height: pxToRem(154), width: pxToRem(190) }}
      />
      <Typography
        sx={{
          marginTop: pxToRem(24),
          fontSize: pxToRem(22),
          fontWeight: '700',
          lineHeight: '33px',
          color: theme.palette.grey[90],
        }}
      >
        <FormattedMessage id='you.are.offline' />
      </Typography>
      <Typography
        sx={{
          marginTop: pxToRem(24),
          fontSize: pxToRem(18),
          fontWeight: '400',
          lineHeight: '27px',
          color: theme.palette.grey[70],
          maxWidth: '80%',
        }}
      >
        <FormattedMessage id='you.are.offline.desc' />
      </Typography>
    </Box>
  );
};

export default OfflineDialog;
